import { EmbeddedContentDefinition } from 'modules/graphql';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { getIsEditMode } from 'modules/templateEditor/common';
import { useQueryParamContext } from 'modules/templateEditor/context/QueryParamContext';
import { DISPLAY_CONTENT } from '../constants';
import { getCharacterCountText } from '../utils';
import { TextAreaField } from './components';

export const Title = () => {
  const { view } = useQueryParamContext();
  const { isEditMode, liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const { title: embeddedTitle } = liveTemplate.mediumData as EmbeddedContentDefinition;
  const title = embeddedTitle || '';
  const isEditModeVisible = getIsEditMode(view, isEditMode);

  const setTitle = (updatedTitle: string) =>
    setCurrentMediumField('title', updatedTitle.length ? updatedTitle : null);

  return (
    <TextAreaField
      isEditMode={isEditModeVisible}
      label={DISPLAY_CONTENT.settings.formTitleLabel}
      mediumDataKey="title"
      mediumDataValue={title}
      setMediumDataValue={setTitle}
      restrictionText={getCharacterCountText(title)}
    />
  );
};
